/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReadReceipt } from './ReadReceipt';
import {
    ReadReceiptFromJSON,
    ReadReceiptFromJSONTyped,
    ReadReceiptToJSON,
    ReadReceiptToJSONTyped,
} from './ReadReceipt';

/**
 * 
 * @export
 * @interface ListReadReceipts200Response
 */
export interface ListReadReceipts200Response {
    /**
     * 
     * @type {Array<ReadReceipt>}
     * @memberof ListReadReceipts200Response
     */
    items: Array<ReadReceipt>;
}

/**
 * Check if a given object implements the ListReadReceipts200Response interface.
 */
export function instanceOfListReadReceipts200Response(value: object): value is ListReadReceipts200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ListReadReceipts200ResponseFromJSON(json: any): ListReadReceipts200Response {
    return ListReadReceipts200ResponseFromJSONTyped(json, false);
}

export function ListReadReceipts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListReadReceipts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ReadReceiptFromJSON)),
    };
}

export function ListReadReceipts200ResponseToJSON(json: any): ListReadReceipts200Response {
    return ListReadReceipts200ResponseToJSONTyped(json, false);
}

export function ListReadReceipts200ResponseToJSONTyped(value?: ListReadReceipts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ReadReceiptToJSON)),
    };
}

